import React from "react";
import PageScaffold from "../../components/PageScaffold";
import { Box } from "@chakra-ui/react";

const CBOOrders = () => {
  return (
    <PageScaffold title="CBO Orders" isHeaderVisible={true}>
      <Box height="calc(100vh - 64px)" width="100%">
        <iframe
          src="https://garaaz.retool.com/apps/CBO%20Orders"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="CBO Orders"
        />
      </Box>
    </PageScaffold>
  );
};

export default CBOOrders;
